export default "__VITE_ASSET__CdSR$xBw__"